/* This component will be used for the minibasket which opens up from the right in a sidebar/drawer */

import styles from "../Basket/Basket.module.scss";
import stylesWishlist from "./Wishlist.module.scss";
import WishListProductTile from "./WishlistProductTile";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import Srcset from "@/components/common/Srcset";
import { openWishlistSidebar } from "@/redux/actions/wishlistAction";
import { useDispatch } from "react-redux";
import { makeId } from "@/helpers/userHelpers";
import ShareWishlist from "./ShareWishlist";
import CTA from "../common/CTA";
import FavouriteIcon from "../common/FavouriteIcon";
import { handleOpeningOfAccountSidebar, openAccountSidebar,openAccountSidebarFromPwaHeader } from "@/redux/actions/loggedInUser";
import { setGlobalActiveTab } from "@/redux/actions/generalAction";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { useRouter } from "next/compat/router";
import { setDrawerSection } from "@/redux/actions/drawerAction";
import UploadIcon from "../Logos/Upload";
import EmptyWishlist from "./EmptyWishlist";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { isGuest } from "@/redux/actions/pwaAction";

export default function Wishlist(props) {
  const [wishlist, setWishlist] = useState([]);
  const [shareWishlistOpen, setShareWishlistOpen] = useState(false);
  const dispatch = useDispatch();
  const logedIn = useSelector((state) => state.loginUser);
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width: 767px)");

  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const handleShareWishlist = (value) => setShareWishlistOpen(value);

  // To update wishlist whenever redux state changes from any other component (i.e. when item is added or removed from wishlist from PDP, PLP, etc.)
  const wishlistItems = useSelector((state) => state.wishlist.wishlist);
  const wishlistHashId = useSelector((state) => state.wishlist.wishlistHashId);
  const custData = useSelector((state) => state.loginUser);
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    if (wishlistItems && Array.isArray(wishlistItems)) {
      setWishlist(wishlistItems);
    }
  }, [wishlistItems]);

  useEffect(() => {
    if (!wishlistSidebarOpen) {
      setShareWishlistOpen(false);
    }
  }, [wishlistSidebarOpen]);
  const sigInFunc=()=>{
    if(!logedIn.userLoggedIn) {
      dispatch(openAccountSidebar(true));
      dispatch(openWishlistSidebar(false))
      setCookie("show_wishlist", true);
      setCookie("hide_signin_cross", true);
      dispatch(openAccountSidebarFromPwaHeader(false));
    }
  }

  //this fucntion is used to show the wishlist drawer only if user is clicking on wishlist sign in or create account link and the page reloads
  const wishlistFunc=()=>{
    if(logedIn.userLoggedIn) {
      let wish = getCookie("show_wishlist_reload");
      if(wish){
        setTimeout(() => {
          dispatch(openAccountSidebar(false))
          dispatch(openWishlistSidebar(true))
          //  after dispatching wishlist list drawer delete this cookie to prevent multiple drawer issue
          deleteCookie("show_wishlist_reload")
        }, 2500);
      }
    }
  }

  useEffect(()=>{
    // dispatch(openAccountSidebar(true));
    if (router.asPath.includes("rewards")||router.asPath==("/")) {
      wishlistFunc()
    }
  },[])

  useEffect(() => {
    if(typeof document !== undefined && isPWA){
      let ele = document.querySelectorAll(".back_icon")
      console.log(ele)
      ele.forEach((item)=>{
        console.log(item)
        item.style.top = "65px"
      })
    }
  },[shareWishlistOpen])

  const numWishlistedItems = wishlist.length;

  return (
    <>
      {shareWishlistOpen ? (
        <ShareWishlist
          handleShareWishlist={handleShareWishlist}
          custId={custData?.userData?.id}
          parentClass={props.parentClass}
          wishlistHashId={wishlistHashId}
        />
      ) : (
        <>
          <div className={`${stylesWishlist.account_back} wishlist-back-btn`}>
            <a
              onClick={() => {
                if (props.activeTab) {
                  props.activeTab("");
                }
                dispatch(openWishlistSidebar(false));
              }}
            >
              <Srcset
                requirePath={true}
                svgFile={true}
                className={"back_icon"}
                src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
                alt="back button"
                height="16"
                width="19.11"
                tabIndex={0}
              />
            </a>
          </div>
          <div
            className={`${styles.sidebar_content} ${stylesWishlist.sidebar_content} ${accountSidebarOpen? stylesWishlist.account_wishlist:""}`}
          >
            <div className={`${styles.your_bag} ${stylesWishlist.your_bag}`}>
              <div
                className={`${styles.heading} ${stylesWishlist.heading} ${stylesWishlist.wishlist_header}`}
              >
                <div
                  id={`WishlistHeadMob-${makeId(3)}`}
                  className={`x-large-xs xx-large-sm xx-large-md light`}
                >
                  Your wishlist
                </div>
              </div>
              {!isMobile && logedIn.userLoggedIn&& numWishlistedItems != 0 && <div
                id={`WishlistShareMob-${makeId(3)}`}
                className={`${stylesWishlist.share_button} ${accountSidebarOpen && stylesWishlist.account_open} xx-small-xs xx-small-sm x-small-md`}
                onClick={() => {
                  setShareWishlistOpen(true);
                }}
                tabIndex={0}
                >
                <span className={stylesWishlist.upload_icon}> <UploadIcon/></span>
                Share
              </div>}
              <div
                className={`${stylesWishlist.item} xx-small-xs xx-small-sm x-small-md`}
              >
                {numWishlistedItems === 1
                  ? "1 item"
                  : `${numWishlistedItems} items`}
              </div>
              {isMobile && logedIn.userLoggedIn&& numWishlistedItems != 0 && <div
                id={`WishlistShareMob-${makeId(3)}`}
                className={`${stylesWishlist.share_button} ${accountSidebarOpen && stylesWishlist.account_open} xx-small-xs xx-small-sm x-small-md`}
                onClick={() => {
                  setShareWishlistOpen(true);
                }}
                tabIndex={0}
                >
                <span className={stylesWishlist.upload_icon}> <UploadIcon/></span>
                Share
              </div>}
            </div>
            {
              !logedIn.userLoggedIn && numWishlistedItems>0 && <div className={`${styles.wishlist_msg_wrapper} bg-silk`}>
                <span className={`${styles.wishlist_msg_wrapper_img}`}>
                  <FavouriteIcon
                    height="12px"
                    width="14px"
                  />
                </span>
                <span className={` xx-small-xs x-small-sm small-md ${styles.wishlist_msg_wrapper_msg}`}>
                    {/* if user using PWA and not using it for the first time then setting guest state to false */}
                    To save or share your wishlist please {" "}
                    <a tabIndex={0} 
                       onClick={() => { 
                        dispatch(setDrawerSection("login")); 
                        sigInFunc(); 
                        dispatch(isGuest(false));
                      }} 
                      className="ga4-signin-wishlist">sign in</a>{" "} or{" "}
                      <a tabIndex={0} 
                        onClick={() => { 
                        dispatch(setDrawerSection("register")); 
                        sigInFunc(); 
                        dispatch(isGuest(false));
                        }} 
                        className="ga4-createaccount-wishlist">create an account</a>
                </span>
              </div>
            }
            {wishlist && wishlist.length > 0 ? (
              <div className={`${stylesWishlist.product_list}`}>
                {/* Slice used to avoid mutating original array and causing redux error */}
                {wishlist
                  .slice()
                  .reverse()
                  .map((product, index) => {
                    return (
                      <WishListProductTile
                        key={product.ProductVariantId}
                        product={product}
                        device={isPWA ? "app": isMobile ? "mobile" : "desktop"}
                      />
                    );
                  })}
              </div>
            ) :
              <EmptyWishlist />
            }
          </div>
        </>
      )}
    </>
  );
}
